import { ToastContainer } from 'react-toastify';
import Router from './Routes';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider, useAuth } from './Auth';
import { BrowserRouter } from 'react-router-dom';
import DocumentViewerComponent from './containers/DocumentViewerComponent';
import { useEffect, useState } from 'react';
import "./print.css";
import { s3Config } from './containers/constants/configs';
import DatabaseLossNotification from './containers/DatabaseLossNotification';
import FloatingNotificationButton from './containers/FloatingNotificationButton';

function AppContent() {
  const { userData } = useAuth();
  const [showDatabaseNotification, setShowDatabaseNotification] = useState(false);

  useEffect(() => {
    // Only show notification for unauthenticated users
    if (!userData) {
      // Check if notification has been shown before
      const hasSeenNotification = localStorage.getItem('hasSeenDatabaseNotification');
      if (!hasSeenNotification) {
        setShowDatabaseNotification(true);
      }
    }
  }, [userData]);

  const handleCloseNotification = () => {
    setShowDatabaseNotification(false);
    // Mark as seen in localStorage so it won't show again
    localStorage.setItem('hasSeenDatabaseNotification', 'true');
  };

  useEffect(() => {
    document.oncontextmenu = (event) => {
      event.preventDefault();
    };
  }, []);
  
  return (
    <>
      {/* <Notice /> */}
      <Router />
      {/* <DocumentViewerComponent /> */}
      <ToastContainer />
      
      {/* Database Loss Notification - Only for unauthenticated users */}
      {/* {showDatabaseNotification && !userData && (
        <DatabaseLossNotification 
          onClose={handleCloseNotification}
        />
      )} */}
      
      {/* Floating Notification Button - Always visible unless permanently hidden */}
      {/* <FloatingNotificationButton /> */}
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
